var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv_flexalign_center act_layout"},[_c('div',{staticClass:"act_button",on:{"click":function($event){return _vm.change(25)}}},[_vm._v("+")]),_c('div',{staticClass:"act_button",on:{"click":function($event){return _vm.change(-25)}}},[_vm._v("-")]),_c('div',{staticClass:"percent"},[_vm._v(_vm._s(_vm.sliderValue)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }